<div>
  <div class="row">
    <div class="col-5 mb-3">
      <h2 class="title-list">List of Users</h2>
    </div>
    <div class="col-2">
      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon1">
          <i class="bi bi-search"></i>
        </span>
        <input type="text" class="form-control input-label" placeholder="Search" [(ngModel)]="textoBusqueda"
          (input)="onSearchChange()" />
      </div>
    </div>

    <div class="col-2 text-end">
      <div class="col text-end">
        <button class="btn btn-primary" (click)="navigateToCreateUser()">
          Create User
        </button>
      </div>
    </div>

    <div class="col-1 text-end">
      <button *ngIf="permissionsService.editPermission && permissionsService.readPermission" class="btn btn-secondary" (click)="exportListPartnersToExcel()">
        <i class="bi bi-file-earmark-excel"></i>
      </button>
    </div>

    <div class="col-1 text-end">
      <button class="btn btn-secondary" (click)="isFilteredByStatus ? clearFilter() : filterByStatus(2)" appTooltip="Show Archived Users">
        <i class="bi bi-archive"></i>
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="table-responsive rounded-5">
        <table class="table table-striped mb-0">
          <caption class="d-none">
            List of users and their details
          </caption>
          <thead class="head-table">
            <tr>
              <th class="px-4 py-3 align-middle">User Account</th>
              <th class="px-4 py-3 align-middle">User Role</th>
              <th class="px-4 py-3 align-middle">Name</th>
              <th class="px-4 py-3 align-middle">Email</th>
              <th class="px-4 py-3 align-middle">Contact Number</th>
              <th class="px-4 py-3 align-middle">Status</th>
              <th class="px-4 py-3 align-middle">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="
                  let user of users
                    | search : textoBusqueda : camposBusqueda
                    | slice : (currentPage - 1) * recordsPerPage : currentPage * recordsPerPage
                ">
              <td class="px-4 py-3 align-middle" [style.opacity]="user.userStatus === 0 ? '0.6' : '1'"
                title="{{ user.userId }}">
                {{ user.userId }}
              </td>
              <td class="px-4 py-3 align-middle" [style.opacity]="user.userStatus === 0 ? '0.6' : '1'"
                title="{{ user.typeUser }}">
                {{ user.typeUser }}
              </td>
              <td class="px-4 py-3 align-middle" [style.opacity]="user.userStatus === 0 ? '0.6' : '1'"
                title="{{ user.userNames }}">
                {{ user.userNames }}
              </td>
              <td class="px-4 py-3 align-middle" [style.opacity]="user.userStatus === 0 ? '0.6' : '1'"
                title="{{ user.userMail }}">
                {{ user.userMail }}
              </td>
              <td class="px-4 py-3 align-middle" [style.opacity]="user.userStatus === 0 ? '0.6' : '1'"
                title="{{ user.userPhone }}">
                {{ user.userPhone }}
              </td>
              <td class="px-4 py-3 align-middle">
                <div *ngIf="user.userStatus === 0 || user.userStatus === 1" class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="user.userStatus"
                    id="flexSwitchCheckDefault" [checked]="user.userStatus === 1"
                    [disabled]="!permissionsService.editPermission" (change)="
                        toggleStatus($event, user);
                        setSelectedCustomer(user);
                        openConfirmationModal(user)
                      " data-bs-toggle="modal" data-bs-target="#modalSwitch" />
                </div>
                <div *ngIf="user.userStatus === 2">
                  <span class="archived">Archived</span>
                </div>
              </td>
              <td class="px-4 py-3 align-middle">
                  <div class="d-flex gap-2">
                      <!-- Botón Editar con icono pencil-square -->
                      <button *ngIf="user.userStatus !== 2 && permissionsService.editPermission" class="btn btn-info"
                              (click)="navigateToUpdateUser(user)" style="background-color: #d1e7dd; border: 3px solid #d1e7dd" appTooltip="Edit User">
                          <i class="bi bi-pencil-square" style="color: #146c43"></i>
                      </button>

                      <!-- Кнопка «Удалить» со значком «Архив» -->
                      <button *ngIf="user.userStatus !== 2 && permissionsService.archivePermission" class="btn btn-danger"
                              data-bs-toggle="modal" data-bs-target="#modalArchive" (click)="setArchivedCustomer(user)"
                              style="background-color: #f8d7da; border: 3px solid #f8d7da" appTooltip="Archive User">
                          <i class="bi bi-archive" style="color: #b02a37"></i>
                      </button>

                      <!-- Кнопка «Восстановить» со значком «Архив» -->
                      <button *ngIf="user.userStatus === 2 && permissionsService.archivePermission" class="btn btn-danger"
                              data-bs-toggle="modal" data-bs-target="#modalArchive" (click)="setArchivedCustomer(user)"
                              style="background-color: #7ab956; border: 3px solid #7ab956" appTooltip="Restore User">
                        <i class="bi bi-archive"></i>
                      </button>

                      <!-- Botón View con icono eye -->
                      <button class="btn btn-success" style="background-color: #cfe2ff; border: 3px solid #cfe2ff"
                              *ngIf="permissionsService.readPermission" (click)="navigateToCustomerView(user)" appTooltip="View User">
                          <i class="bi bi-eye" style="color: #0a58ca"></i>
                      </button>
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="row d-flex align-items-center justify-content-between">
    <div class="col-2">
      <label>
        Showing {{ (currentPage - 1) * recordsPerPage + 1 }} to {{ currentPage * recordsPerPage < users.length ?
          currentPage * recordsPerPage : users.length }} out of {{ users.length }} entries </label>
    </div>
    <div class="col-7">
      <div class="col-12 pagination text-left ">
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <a class="page-link" href="javascript:void(0)" tabindex="-1" aria-disabled="true"
                (click)="previousPage()">
                <i class="bi bi-chevron-left"></i>
              </a>
            </li>
            <ng-container *ngFor="let page of pages">
              <li class="page-item" [class.active]="page === currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="changePage(page)">{{ page }}</a>
              </li>
            </ng-container>
            <li class="page-item" [class.disabled]="currentPage === totalPages">
              <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
                <i class="bi bi-chevron-right"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
<div class="modal fade" id="modalSwitch" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold;">
          User Active/Inactive
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="updateUserStatus(false)"></button>
      </div>
      <div class="modal-body">
        Are you sure you want to Activate/Deactivate this user?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updateUserStatus(false)">
          Close
        </button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updateUserStatus(true)">
          Yes, Activate/Desactivate
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modalArchive" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold;">User {{isFilteredByStatus ? 'Restore' : 'Archive'}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="updateUserStatus(false)"></button>
      </div>
      <div class="modal-body">
          Are you sure you want to {{isFilteredByStatus ? 'Restore' : 'Archive'}} this user?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updateUserStatus(false)">
          Close
        </button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updateUserStatus(true)">
            Yes, {{isFilteredByStatus ? 'Restore' : 'Archive'}}
        </button>
      </div>
    </div>
  </div>
</div>